import React from "react";
import cn from "classnames";
import styles from "./Form.module.sass";
import Icon from "../Icon";

const Form = ({
  className,
  onSubmit,
  placeholder,
  value,
  setValue,
  type,
  name,
  icon,
  onChange,
  iconSize
}) => {
  return (
    <div className={cn(className, styles.form)}>
      <input
        className={styles.input}
        type={type}
        value={value}
        onChange={(e) => {

          if (onChange) {
            onChange()
          } else {
            setValue(e.target.value);
          }
        }}
        name={name}
        placeholder={placeholder}
        required
      />
      <button className={styles.result}>
        <Icon name={icon} size={`${iconSize ? iconSize : "24px"}`} />
      </button>
    </div>
  );
};

export default Form;
